const DashboardStyle = {
  dashboard_Container: {
    padding: '0 24px 23px',
  },
  agentName: {
    fontStyle: 'normal',
    fontFamily: 'dana-bold',
    fontSize: '12px',
    textAlign: 'left',
    color: '#707070',
    paddingLeft: '8px',
  },
  devText:{
    fontWeight: "700",
    fontSize: "12px",
    color: "#707070",
    paddingTop:'3px'
  },
  rightTitle: {
    fontWeight: '400',
    fontSize: '14px',
    color: '#707070',
  },
  leftTitle: {
    fontFamily: 'dana-bold',
    fontSize: '14px',
    // textAlign: 'left',
    color: 'rgba(77, 77, 78, 0.9)',
  },
  dividerStyle: {
    height: '0.1px',
    background: '#D8D8D8',
    margin: '14px auto',
    width: '100%',
  },
  editBtn: {
    width: '126px',
    background: '#F4F4F4 !important',
    border: '1px solid #FFFFFF !important',
    boxShadow:
      '2px -2px 4px #FFFFFF, 4px 4px 15px rgba(0, 0, 0, 0.08) !important',
    borderRadius: '98px !important',

    fontFamily: 'dana-bold',
    fontSize: '10px !important',
    color: '#3CC0C3 !important',
  },
  exitBtn: {
    width: '65px',
    background: '#F4F4F4 !important',
    border: '1px solid #FFFFFF !important',
    boxShadow:
      '2px -2px 4px #FFFFFF, 4px 4px 15px rgba(0, 0, 0, 0.08) !important',
    borderRadius: '98px !important',

    fontFamily: 'dana-bold',
    fontSize: '10px !important',
    color: '#707070 !important',
  },
  editBtnContainer: {
    display: 'flex',
    marginTop: '20px !important',
  },
  accordionData_Container: {
    alignItems: 'center',
    background: '#F7F7F7',
    padding: '35px 24px',
    borderRadius: '0 0 16px 16px',
  },
  startTextStyle: {
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '32px',
    color: '#753CBE',
    textAlign: 'center',
    width: '100%',
    marginTop: '33px',
    marginBottom: '16px',
  },
  welcomeTextStyle: {
    fontFamily: 'dana-bold',
    fontSize: '14px',
    lineHeight: '32px',
    textAlign: 'center',
    color: '#4E4E4E',
    width: '100%',
    marginBottom: '40px',
  },
  dashboardInfo_RightTitle: {
    fontWeight: '400',
    fontSize: '16px',
    color: '#4E4E4E',
  },
  dashboardInfo_LeftTitle: {
    fontFamily: 'dana-bold',
    fontSize: '20px',
    textAlign: 'right',
    color: '#753CBE',
  },
  dashboardInfo_container: {
    background: '#FFFFFF',
    border: '1px solid #F5F5F5',
    boxShadow: '-4px -4px 15px #FFFFFF, 4px 4px 15px rgba(172, 172, 172, 0.5)',
    borderRadius: '20px',
    height: '48px',
    margin: 'auto 24px',
    marginBottom: '14px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 14px',
  },
  editHeader: {
    fontFamily: 'dana-bold',
    fontSize: '16px',
    lineHeight: '25px',
    textAlign: 'center',
    color: '#3CC0C3',
    width: '100%',
  },
  saveBtn: {
    background: ' #F4F4F4 !important',
    border: '1px solid #FFFFFF !important',
    boxShadow:
      '-6px -6px 30px #FFFFFF, 6px 6px 30px rgba(174, 174, 192, 0.4) !important',
    borderRadius: '16px !important',
    fontFamily: 'dana-bold',
    fontSize: '14px !important',
    color: '#3CC0C3 !important',

    width: '90px',
    height: '45px',
    marginTop: '35px !important',
  },
  closeIconStyle: {
    color: '#707070',
    fontSize: '1rem !important',
    position: 'absolute',
    top: '23px',
    left: '23px',
    cursor: 'pointer',
  },
  modalContainer: {
    position: 'absolute !important',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '30px 16px 24px',
    width: '312px !important',
    fontFamily: 'dana-bold',
    background: '#F5F5F5',
    border: '1px solid #FFFFFF',
    boxShadow: '8px 8px 20px rgba(172, 172, 172, 0.5), -4px -4px 20px #FFFFFF',
    borderRadius: '16px',

    textAlign: 'center',
    color: '#707070',
  },
};

export default DashboardStyle;
